import { useCallback } from 'react';
import {
  sendChatDeliverMessageEvent,
  sendChatReadAllMessagesEvent,
  sendChatReadMessageEvent,
  sendChatSendMessageEvent,
} from '@connect-x-app/hybrid-data-access';
import { MessageStatusUpdateSocket, SendSocketMessage, SocketMessage } from '@connect-x-app/shared-domain-models';

export const useChatMessageSocketSendEvents = () => {
  const sendChatMessage = useCallback(async (message: SendSocketMessage) => {
    return await sendChatSendMessageEvent(message);
  }, []);

  const sendChatDeliverMessage = useCallback((payload: MessageStatusUpdateSocket) => {
    sendChatDeliverMessageEvent(payload);
  }, []);

  const sendChatReadMessage = useCallback((payload: MessageStatusUpdateSocket) => {
    sendChatReadMessageEvent(payload);
  }, []);

  const sendChatReadAllMessages = useCallback((payload: SocketMessage) => {
    sendChatReadAllMessagesEvent(payload);
  }, []);

  return {
    sendChatDeliverMessage,
    sendChatMessage,
    sendChatReadAllMessages,
    sendChatReadMessage,
  };
};
